<template>
  <div class="tab_filter_container" v-bind="$attrs">
    <div class="tab_filter_wrap">
      <div
        v-for="item in filterList"
        :key="item.value"
        :class="['tab_filter_item', activeKey === item.value ? 'is_active' : '', item.disabled ? 'is_disabled' : '']"
        @click="onFilterChange(item)"
        :data-testid="item.testId"
      >
        {{ item.label }}
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
/**
 * @param array filterList
 * @param {label:string | number,value:string | number,disabled?:boolean,testId?: string} filterListItem
 * @callback function filterChange(value)
 */
export default {
  props: {
    filterList: {
      type: Array,
      default: []
    },
    // 默认选中值
    defaultValue: {
      default: null
    }
  },
  data() {
    return {
      activeKey: this.defaultValue || this.filterList[0].value
    };
  },
  methods: {
    onFilterChange(item) {
      if (item.disabled) return;
      this.activeKey = item.value;
      this.$emit('filterChange', item.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.tab_filter_container {
  display: flex;
  align-items: center;
}
.tab_filter_wrap {
  height: 40px;
  display: flex;
  align-items: center;
  background-color: #ebf1ff;
  border-radius: 28px;
  padding: 0 4px;
  .tab_filter_item {
    height: 32px;
    line-height: 32px;
    padding: 0 12px;
    border-radius: 22px;
    font-size: 16px;
    color: $primary-dark-blue;
    background-color: transparent;
    cursor: pointer;
    @include rtl-sass-prop(margin-right, margin-left, 12px);
    transition: all ease-in-out 0.3s;
    &:last-child {
      @include rtl-sass-prop(margin-right, margin-left, 0);
    }
    &:hover {
      color: $primary-blue;
    }
    &.is_active {
      background-color: $white;
      color: $primary-blue;
      box-shadow: 0px 4px 4px 0px rgba($color: $primary-blue, $alpha: 0.11);
    }
    &.is_disabled {
      color: $placeholder-color;
      cursor: not-allowed;
      &.is_active {
        background-color: $primary-disable;
        color: $placeholder-color;
      }
      &:hover {
        color: $placeholder-color;
      }
    }
  }
}
@media (max-width: 787px) {
  .tab_filter_item{
    font-size: 14px!important;
  }
}
</style>
